import React, { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import PropTypes from 'prop-types';

const propsAreEqual = (prevProps, nextProps) => {
  return prevProps.token === nextProps.token;
};

const PlaidLink = React.memo(({ token = null, receivedRedirectUri =  null, onSuccess = null, onEvent = null, onExit = null,
                                oauthPresent = false, isEmbedded }) => {
  let isOauth = false;
  const config = {
    token,
    onSuccess,
    onEvent,
    onExit,
    isEmbedded,
  };

  if (receivedRedirectUri || oauthPresent) {
    config.receivedRedirectUri = receivedRedirectUri || window.location.href;
    isOauth = true;
  }
  const { open, ready } = usePlaidLink(config);
  useEffect(() => {
    if (isOauth || ready) {
      open();
    }
  }, [ready, open, isOauth]);

  return null;
}, propsAreEqual);

PlaidLink.propTypes = {
  /**
   * It exists when there are banks using oauth
   */
  oauthPresent: PropTypes.string,
  /**
   * Token used to initialize the plaid iFrame
   */
  token: PropTypes.string,

  receivedRedirectUri: PropTypes.string,
  /**
   * A function that is called when a user has successfully connecter an Item.
   */
  onSuccess: PropTypes.func,
  /**
   * A callback that is called during a user's flow in Link.
   */
  onEvent: PropTypes.func,
  /**
   * A callback that is called when a user has specifically exited Link flow.
   */
  onExit: PropTypes.func,

  isEmbedded: PropTypes.bool
};

PlaidLink.displayName = "PlaidLink";
export default PlaidLink;